import { capitalizeFirstLetter } from "./helpers";
/**
 * Checks if a string contains only digits
 *
 * @param {String} value
 * @param {String} field
 *
 * @returns {Boolean} true or false
 */
export const validateDigits = (value, field = "field", allowPoint = false) => {
  const newVal = allowPoint ? value.toString().replace(/\./g, "") : value;
  const digitsRegex = new RegExp("^[0-9]+$");
  const errors = {};
  if (digitsRegex.test(newVal) === true) return { errors, valid: true };
  errors[field] = `${capitalizeFirstLetter(field)} must contain only digits`;
  return { errors, valid: false };
};

export const validateRequired = form => {
  let valid = true;
  const errors = {};
  for (const [key, value] of Object.entries(form)) {
    if (value === "" || value === null) {
      valid = false;
      errors[key] = `${capitalizeFirstLetter(key)} is required`;
    }
  }

  return { errors, valid };
};

export const checkFormErrors = formErrors => {
  let state = {};
  for (const [key, value] of Object.entries(formErrors)) {
    if (value && value !== "") {
      state[key] = false;
    }
  }
  return state;
};

export const validatePassword = password => {
  let valid = true;
  const errors = {};
  const strongPwdRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
  );
  if (!strongPwdRegex.test(password)) {
    errors["password"] =
      "Password must contain at least an upper case letter, a lower case letter, and a number";
    valid = false;
  }
  return { errors, valid };
};
